import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { AddLeaderProfileDefault } from "./AddLeaderProfileDefault";
import { AddLeaderProfileFUHSD } from "./AddLeaderProfileFUHSD";

/**
 * Main AddLeaderProfile component that routes to the appropriate
 * affiliation-specific dialog based on the user's affiliation.
 */
export function AddLeaderProfile(props) {
  const userProfile = useSelector((state) => state.user.currentUser);
  
  // Parse user profile to get affiliation
  const parsedUserProfile = useMemo(() => {
    let parsedProfile;
    try {
      if (
        userProfile &&
        typeof userProfile === "string" &&
        userProfile.trim() !== ""
      ) {
        parsedProfile = JSON.parse(userProfile);
      } else {
        parsedProfile = userProfile;
      }
    } catch (error) {
      console.error("Error parsing userProfile JSON:", error);
      parsedProfile = {};
    }
    return parsedProfile;
  }, [userProfile]);

  const affiliation = parsedUserProfile?.affiliation;

  // Route to FUHSD-specific dialog if user is affiliated with FUHSD
  if (affiliation === "FUHSD") {
    return <AddLeaderProfileFUHSD {...props} />;
  }

  // Default dialog for all other affiliations or no affiliation
  return <AddLeaderProfileDefault {...props} />;
}
